import { Stack } from '@mantine/core';

import { useTranslation } from 'react-i18next';

import { BuyerSimBidResponseList } from '../../features/bidResponse/components/buyerSimulation/components/buyerSimulationList/BuyerSimBidResponseList';
import { Header } from '../../features/bidResponse/components/buyerSimulation/components/buyerSimulationList/Header';
import { useSetPageTitle } from '../../shared/hooks/useSetPageTitle.hook';

export const BuyerSimulationPage = () => {
  const { t } = useTranslation('buyerSimulation');
  useSetPageTitle(t('title'));
  return (
    <Stack
      spacing="05"
      w="100%"
      p="07"
      mb="15"
      sx={{
        background: `linear-gradient(180deg, #EFF8FF -5.79%, #FFFFFF 19.49%)`,
      }}
    >
      <Header />
      <BuyerSimBidResponseList />
    </Stack>
  );
};
